import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { NgDatepickerModule } from 'ng2-datepicker';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MyDatePickerModule } from 'mydatepicker';
import { AuthModule, AUTHSETTINGS, AUTHSTORAGE } from '@mydocma/auth';
import { MediatorService, MYDOCMASETTINGS, MediaQueryService, APPSTORAGE } from '@mydocma/core';
import { CustomerModule } from '@mydocma/customer';
import { ProjectModule, ProjectService } from '@mydocma/project';
import {FileType, ModuleTranslateLoader} from '@larscom/ngx-translate-module-loader';
import { MainComponent } from './main/main.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppContainerModule, APP_CONTAINER_SETTINGS } from '@mydocma/app-container';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { JwtInterceptor } from 'projects/mydocma/pt/src/lib/_helpers/jwt.interceptor';
import { MatIconModule, MatSnackBarModule } from '@angular/material';


export function createTranslateLoader(http: HttpClient) {
  const baseTranslateUrl = './assets/i18n';

  return new ModuleTranslateLoader(http, {
    modules: [
      { moduleName: 'app-container', baseTranslateUrl, fileType: FileType.JSON },
      { moduleName: 'project', baseTranslateUrl, fileType: FileType.JSON },
      { moduleName: 'customer', baseTranslateUrl, fileType: FileType.JSON },
      {moduleName: 'comp-lib', baseTranslateUrl, fileType: FileType.JSON},
    ],
  });
}

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    AppContainerModule,
    AuthModule.forRoot(),
    CustomerModule.forRoot(),
    ProjectModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    MatIconModule,
    MatSnackBarModule
  ],
  providers: [
    { provide: AUTHSETTINGS, useValue: environment.authConfig },
    { provide: APPSTORAGE, useValue: localStorage },
    { provide: MYDOCMASETTINGS, useValue: environment.mydocmaConfig },
    {provide: APP_CONTAINER_SETTINGS, useValue: {}},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    MediatorService,
    MediaQueryService,
    [DatePipe]],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private translate: TranslateService,
  ) {
    this.translate.addLangs(['en', 'de']);
    this.translate.setDefaultLang('de');
    this.translate.use('de');
  }
}
